import formatFileSize from './utils'

const messages = {
  _default: () => `vrijednost nije valjana.`,
  after: (field, [target, inclusion]) =>
    `mora biti nakom ${inclusion ? 'ili jednak s: ' : ''}${target}.`,
  alpha_dash: () =>
    `polje može sadržavati alfa-numeričke znakove kao i povlake ili donje crte.`,
  alpha_num: () =>
    `polje može sadržavati alfa-numeričke znakove.`,
  alpha_spaces: () =>
    `polje smije sadržavati samo slovne oznake i razmake.`,
  alpha: () => `polje smije sadržavati samo slovne oznake.`,
  before: (field, [target, inclusion]) =>
    `mora biti prije ${inclusion ? 'ili isto jednako s ' : ''}${target}.`,
  between: (field, [min, max]) =>
    `polje mora biti između  ${min} i ${max}.`,
  confirmed: () => `konfirmacija ne odgovara.`,
  credit_card: () => `polje nije valjano.`,
  date_between: (field, [min, max]) =>
    `mora biti između ${min} i ${max}.`,
  date_format: (field, [format]) =>
    `mora biti u formatu ${format}.`,
  decimal: (field, [decimals = '*'] = []) =>
    `polje mora biti numerička vrijednost i može sadržavati ${
      !decimals || decimals === '*' ? '' : decimals
    } decimalne točke.`,
  digits: (field, [length]) =>
    `polje mora biti numerička vrijednost i mora točno sadržavati ${length} znamenke.`,
  dimensions: (field, [width, height]) =>
    `polje mora biti širine ${width} pixela s ${height} pixela.`,
  email: () => `polje mora biti valjana email adresa.`,
  ext: () => `polje mora biti valjana datoteka.`,
  image: () => `polje mora biti slika.`,
  in: () => `polje mora biti valjana vrijednost.`,
  integer: () => `polje mora biti cijeli broj.`,
  ip: () => `polje mora biti valjana ip adresa.`,
  length: (field, [length, max]) => {
    if (max) {
      return `duljina mora biti između ${length} i ${max}.`
    }

    return `duljina mora biti ${length}.`
  },
  max: (field, [length]) =>
    `polje ne smije biti duže od ${length} znakova.`,
  max_value: (field, [max]) => `polje mora biti ${max} ili manje.`,
  mimes: () => `polje mora sadržavati valjani tip datoteke.`,
  min: (field, [length]) =>
    `polje mora imati barem ${length} znakova.`,
  min_value: (field, [min]) => `polje mora biti  ${min} ili više.`,
  not_in: () => `polje mora biti valjana vrijednost.`,
  numeric: () => `polje smije sadržavati samo numeričke znakove.`,
  regex: () => `format polja nije valjan.`,
  required: () => `polje je obavezno.`,
  size: (field, [size]) =>
    `veličina mora biti manja od ${formatFileSize(size)}.`,
  url: () => `polje nije valjan URL.`,
  fullName: () => 'nije valjano (prezime, ime i maks. 120 znakova)',
  emailInput: () => 'polje mora biti valjana email adresa.',
  fullNamePerCountry: () => 'nije valjano (prezime, ime i maks. 18 znakova)',
  invalidCharPerCountry: () => 'is not valid (contains invalid characters)',
  orderNumberPerCountry: () => `is too long`,
  blackListZipCodePerCountry: () => 'code is not allowed!'
}

const locale = {
  name: 'hr',
  messages,
  attributes: {}
}

export default locale



// WEBPACK FOOTER //
// ./client/translations/vee-validate/hr.js